import React, { useState, forwardRef, useMemo } from 'react';
import {
    FormControl,
    Select,
    MenuItem,
    ListItemText,
    Typography,
    ListSubheader,
    TextField,
    InputAdornment,
    InputLabel,
    Checkbox
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { getSendReceive } from 'src/services/feedbackService';
import '../Feedback.css';

interface sendReceiveProps {
    value: number[];
    onChange: (e: any) => void;
    disabled?: boolean;
    required?: boolean;
    label?: string,
    isSender: boolean
}

const SendReceiveSelectDropdown = forwardRef((props: sendReceiveProps, _ref) => {
    const [list, setList] = useState([]);
    const [searchText, setSearchText] = useState<string>('');
    const [selectedValues, setSelectedValues] = useState<any[]>(props.value ?? []);

    const fetchSendReceive = (searchText) => {
        getSendReceive(props?.isSender).then((res) => {
            setList(res?.data?.data.filter((option) => containsText(option?.name, searchText)));
        });
    }

    const containsText = (text, searchText) =>
        text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;


    React.useEffect(() => {
        fetchSendReceive(searchText);
    }, []);


    React.useEffect(() => {
        if (props.value === null) {
            setSelectedValues([]);
        }
    }, [props.value]);

    const filteredLists = useMemo(
        () =>
            list.length > 0 &&
            list?.filter((option) => containsText(option?.name, searchText)),
        [list, searchText]
    );

    const handleSelectChange = (event: any) => {
        const values = event.target.value;
        setSelectedValues(values);
        props?.onChange(values.join(','))
    }

    return (
        <FormControl
            fullWidth
            disabled={props?.disabled ? props?.disabled : false}
            className="task-type-dropdown"
        >

            {props?.label && (<InputLabel
                style={{
                    fontSize: '12px'
                }}
            >
                {props?.label}
            </InputLabel>)}
            <Select
                sx={{ mt: '4px' }}
                style={{
                    fontSize: '12px',
                    height: '2rem',
                    marginTop: '8px'

                }}
                multiple
                renderValue={(selected) =>
                    selected
                        .map((id) => {
                            const selectedItem = list.find((item) => item.id === id);
                            return selectedItem?.name;
                        })
                        .join(', ')
                }
                displayEmpty
                size="small"
                value={selectedValues}
                onChange={handleSelectChange}

            >
                {/* {!props?.label && (<MenuItem style={{ display: 'none' }} selected disabled value={''}>
                    Select Category
                </MenuItem>
                )} */}
                <ListSubheader>
                    <TextField
                        id="employee-id"
                        size="small"
                        autoFocus
                        placeholder="Type to search..."
                        fullWidth
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            )
                        }}
                        onChange={(e) => setSearchText(e.target.value)}
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                        onKeyDown={(e) => {
                            if (e.key !== 'Escape') {
                                e.stopPropagation();
                            }
                        }}
                    ></TextField>
                </ListSubheader>
                {filteredLists?.length > 0 &&
                    filteredLists.map((type, i) => {
                        return (
                            <MenuItem key={i} value={type.id}>
                                <Checkbox checked={selectedValues.includes(type.id)} />
                                <ListItemText primary={type.name} />
                            </MenuItem>
                        );
                    })}
            </Select>
        </FormControl>
    );
});

export default SendReceiveSelectDropdown;
